import gql from 'graphql-tag';

import { formTemplateFragment } from '~/shared/graphql-queries/form-templates/index';

export default gql`
  query findOneFormTemplateQuery($filter: FilterFindOneFormTemplateInput!) {
    findOneFormTemplateQuery(filter: $filter) {
      ...FormTemplateFragment
    }
  }
  ${formTemplateFragment}
`;
